import { Fragment, memo } from 'react';

import { CommentRow, InfoRow, InfoRowSection } from 'containers/components/EntityDetailV2';
import { getLiteral } from 'utils/getLiteral';

import { getDurationTextFromDates } from '../../../../utils/activities';
import ActivityDetailContainer from '../ActivityDetailContainer';

const VideoCallDetail = memo(({ activity, getIsCommentCollapsed, labels, shared }) => {
    const { companyContent, finalContactContent, opportunityRow, rightContent, titleRow } = shared;

    const durationText = getDurationTextFromDates(
        activity.videoCallTimeStart,
        activity.videoCallTimeEnd,
    );

    let videoCallParticipants;

    try {
        videoCallParticipants = JSON.parse(activity.videoCallParticipants);
    } catch (e) {
        console.error(e);
    }

    if (videoCallParticipants) {
        videoCallParticipants = videoCallParticipants
            .filter((participant) => participant?.name)
            .map((participant) => participant?.name)
            .join(', ');
    }

    let firstInfoRowLabel = labels.contact;

    if (!finalContactContent && companyContent) {
        firstInfoRowLabel = labels.account;
    }

    return (
        <ActivityDetailContainer
            activity={activity}
            noTabs={false}
            content={{
                main: (
                    <Fragment>
                        <InfoRowSection>
                            <InfoRow label={labels.duration} value={durationText} />
                        </InfoRowSection>
                        {activity.Description && (
                            <CommentRow
                                text={activity.Description}
                                getIsCommentCollapsed={getIsCommentCollapsed}
                            />
                        )}
                    </Fragment>
                ),
                right: (
                    <Fragment>
                        {titleRow}
                        <InfoRowSection>
                            <InfoRow
                                label={labels.account}
                                content={companyContent}
                                rightContent={rightContent}
                            />
                            <InfoRow label={firstInfoRowLabel} value={finalContactContent} />
                            {opportunityRow}
                            <InfoRow label={labels.subject} value={activity.Subject} />
                            <InfoRow
                                label={getLiteral('label_videocall_participants')}
                                value={videoCallParticipants}
                            />
                        </InfoRowSection>
                    </Fragment>
                ),
            }}
        />
    );
});

VideoCallDetail.displayName = 'VideoCallDetail';

export default VideoCallDetail;
